import Auth from '@aws-amplify/auth'
import { Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'

import { useNotification } from 'src/modules/notification'
import { Button, Form, FormikTextField, FIELD_REQUIRED } from 'src/modules/ui'

import FormActions from './FormActions'
import FormHeader from './FormHeader'
import FormLinks from './FormLinks'
import FormLink from './FormLink'
import ForgotPasswordSetNew from './ForgotPasswordSetNew'

export const ForgotPasswordForm = ({
  handleSubmit,
  isSubmitting,
  onClickBackToSignin,
}) => (
  <div>
    <FormHeader title="Forgotten Password" />
    <Form>
      <FormikTextField fullWidth label="Email" name="username" type="email" />
      <FormLinks>
        <FormLink onClick={onClickBackToSignin}>Back To Signin</FormLink>
      </FormLinks>
      <FormActions>
        <Button
          color="primary"
          onClick={handleSubmit}
          isLoading={isSubmitting}
          size="large"
          type="submit"
        >
          Request Reset Code
        </Button>
      </FormActions>
    </Form>
  </div>
)

const ForgotPassword = ({ onStateChange, user = {}, ...props }) => {
  const { showError, showSuccess } = useNotification()
  const [codeSentToUsername, setCodeSentToUsername] = useState()

  const validationSchema = Yup.object().shape({
    username: Yup.string().required(FIELD_REQUIRED),
  })
  const initialValues = { username: '' }

  const handleSubmit = async ({ username }, { setFieldError }) => {
    try {
      await Auth.forgotPassword(username)
      setCodeSentToUsername(username)
    } catch (err) {
      if (err.code === 'UserNotFoundException') {
        setFieldError('username', 'Incorrect username')
      } else {
        showError(err.message)
      }
    }
  }

  const handleResendCode = async () => {
    try {
      await Auth.forgotPassword(codeSentToUsername)
      showSuccess('Code resent')
    } catch (err) {
      showError(err.message)
    }
  }

  useEffect(() => {
    const doSend = async () => {
      const email = user && user.email
      if (email) {
        try {
          await Auth.forgotPassword(email)
          setCodeSentToUsername(email)
        } catch (err) {
          showError(err.message)
        }
      }
    }
    doSend()
  }, [user && user.email])

  return codeSentToUsername ? (
    <ForgotPasswordSetNew
      isReset={!!user.reset}
      onClickResendCode={handleResendCode}
      onStateChange={onStateChange}
      username={codeSentToUsername}
      {...props}
    />
  ) : (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {formik => <ForgotPasswordForm {...formik} {...props} />}
    </Formik>
  )
}

export default ForgotPassword
